import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "../context/ContentContext";

const ease = [0.16, 1, 0.3, 1];

export const Services = () => {
  const { content } = useContent();
  const SERVICES = content.services;
  return (
    <section id="servizi" data-testid="services-section" className="py-24 md:py-36 bg-navy text-paper relative overflow-hidden grain">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <p className="eyebrow mb-5">I nostri servizi</p>
            <h2 className="font-serif font-light text-4xl md:text-5xl leading-tight">
              Tutto ciò che apre, chiude e protegge la tua casa.
            </h2>
          </div>
          <p className="text-paper/60 max-w-sm text-sm md:text-base leading-relaxed">
            Soluzioni complete in ferro, alluminio e PVC — progettate, costruite e
            installate dal nostro team.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-gold/15">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.id || i}
              data-testid={`service-card-${s.id || i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease }}
              className="group relative bg-navy overflow-hidden"
            >
              <div className="relative h-60 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-transparent" />
              </div>
              <div className="p-8">
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-serif text-2xl text-paper">{s.title}</h3>
                  <ArrowUpRight className="text-gold opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-400" size={22} />
                </div>
                <p className="mt-4 text-paper/55 text-sm leading-relaxed">{s.desc}</p>
              </div>
              <span className="absolute bottom-0 left-0 h-px w-0 bg-gold group-hover:w-full transition-all duration-500" />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
